import { userGQLSchema } from "./User";

export const categoryGQLSchema = `
id
MainInfo{
    Title
    Slug
}
Seo{
    Keywords
    Description
}
Info{
    CreatedBy{
        ${userGQLSchema}
    }
    ArticleCount
}
`;
